import { ExternalLink } from 'lucide-react'

interface Integration {
  name: string
  description: string
  url?: string
}

const INTEGRATIONS: Integration[] = [
  // HelpScout retired 2026-04-17 when MailDesk Ultimate replaced it —
  // shared inbox, memory extraction pipeline, PO intake all migrated.
  // Tile removed from the registry 2026-04-24 because the "Open" link
  // was still pointing at the retired HelpScout instance.
  {
    name: 'MailDesk',
    description:
      'Odoo-native email inbox with Exchange Online OAuth and tag/assign workflows. Replaced HelpScout 2026-04-17.',
  },
  {
    name: 'Doc Converter',
    description:
      'PDF-to-SPI-CofA pipeline. Conversions reconcile into the CofA Pipeline module every 5 minutes.',
    url: 'https://docs.siliconesplus.com/',
  },
  {
    name: 'Rhenus Tracking',
    description: 'Freight tracking ingestion every 2 hours.',
  },
  {
    name: 'Label Generator',
    description: 'Customer-specific PDF label generation (Phase 1: Mary Kay).',
  },
]

export function IntegrationsSection() {
  return (
    <section className="flex flex-col gap-4">
      <header>
        <h2 className="text-lg font-semibold text-primary">Integrations</h2>
        <p className="text-sm text-secondary">
          Connected services. Detailed status (last-event timestamp, error
          counts) comes in a future release — for now these cards are a visual
          registry.
        </p>
      </header>

      <ul className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        {INTEGRATIONS.map((i) => (
          <li
            key={i.name}
            className="flex flex-col gap-1 rounded-sm border border-border-subtle bg-surface p-3"
          >
            <header className="flex items-center justify-between gap-2">
              <h3 className="text-sm font-semibold text-primary">{i.name}</h3>
              {i.url ? (
                <a
                  href={i.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-link hover:underline"
                >
                  Open <ExternalLink size={10} />
                </a>
              ) : null}
            </header>
            <p className="text-xs text-secondary">{i.description}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}
